import { projects } from "../data/worklog";
import useLink from "./useLink";

const useRouting = () => {
  const prLink = useLink(); // Ensure prLink is defined;

  const navbarlinks = [

    { section: 'accueil', href: '/' },
    /* { section: 'company',
      href: '/company',
      groupRoutes: [
        { groupLabel: 'Notre compagnie, pour vous servir',
          routes: [
            { label: 'expertise' },
            { label: 'carrières' },
            { label: 'équipe' },
          ]
        },
        { groupLabel: 'The LAWWD Initiatives',
          routes: [
            { label: 'LFA' },
            { label: 'Ventures' },
          ]
        }
      ]
    }, */
    { section: 'portfolio',
      href: '/work',
      groupRoutes: [
        { groupLabel: 'portfolio projects',
          routes: projects.map(project => ({
            label: project.client, // Use the client name as the label
            link: "work/" + prLink(project.client) // Generate the link using prLink
          }))
        }
      ]

    },
    /* { section: 'expertise',
      href: '/expertise',
      groupRoutes: [
        { groupLabel: '',
          routes: [
            { label: servicesList.fr[0] },
            { label: servicesList.fr[1] },
            { label: servicesList.fr[2] },
            { label: servicesList.fr[3] },
          ]
        }
      ]
    }, */
    { section: 'contact',
      href: '/contact',
      /*     groupRoutes: [
            { groupLabel: '',
              routes: [
                { label: 'biz.chat' },
                { label: 'office' },
                { label: 'get a call back' },
              ]
            }
          ] */
    },
    /* { section: 'careers',
      href: '/careers',
      groupRoutes: [
        { groupLabel: '',
          routes: [
            { label: 'internships' },
            { label: 'send your resume' },
            { label: 'open days' },
          ]
        }
      ]
    } */
  ]

  const footerlinks = [
    { section: 'menu',
      links: [
        { label: 'Accueil', hint: "Home", href: '/' },
        // { label: 'Organisation', hint: "Company", href: '/company' },
        // { label: 'Expertise', hint: "Expertise", href: '/expertise' },
        { label: 'Portfolio', hint: "Work", href: '/work' },
        // { label: 'Initiatives', hint: "Initiatives", href: '/initiatives' },
        { label: 'Log', hint: "", href: '/log' },
        // { label: 'lawwdTalks', hint: "LawwdTalks", href: '/lawwdtalks' },
      ]
    },
    { section: 'nous contacter',
      links: [
        // { label: 'bureau', value: "+221 33 860 66 20", href: 'tel:00221778592291' },
        { label: 'bureau', value: "+221 78 438 68 68", href: 'tel:00221784386868' },
        { label: 'email', value: "contact@lawwd.co", href: 'mailto:lawwdagency@gmail.com' },
        { label: 'whatsapp', value:"+221 77 859 22 91", href: 'https://wa.me/00221774386868' },
      ]
    },
    { section: 'nous suivre',
      links: [
        { label: 'instagram', icon: "instagram", link: "", href: 'https://instagram.com/lawwd.co' },
        { label: 'linkedin', icon: "linkedin", link: "", href: 'https://linkedin.com/companies/lawwd' },
        { label: 'twitter / x', icon: "twitter", link: "", href: 'https://twitter.com/lawwdstudios' },
      ]
    },
  ]

  const footerExtra = {
    privacy: {title: "Politique de confidentialité",   link:"p/privacy-policy"},
    resources: {title: "Ressources",   link:"#"},/* p/resources */
    cookies: {title: "Cookies 🍪",   link:"#"},/* p/cookies */
  }


  return {
    navbarlinks,
    footerlinks,
    footerExtra
  }
}

export default useRouting
